<template>
  <div>
    <div class="d-flex mb-2">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          StyleNo：{{
            formData.amzFtyCheckTaskNo ? formData.amzFtyCheckTaskNo : '新增'
          }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          class="mr-2"
          style="font-size: 12px"
          :variant="
            formData.amzFtyCheckTaskStatus === 'N'
              ? 'primary'
              : formData.amzFtyCheckTaskStatus === 'Y'
              ? 'success'
              : formData.amzFtyCheckTaskStatus === 'P'
              ? 'warning'
              : 'danger'
          "
        >
          {{ formData.v_amzFtyCheckTaskStatus || '新增' }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <el-form ref="form" :model="formData" :rules="rules" size="small">
      <el-row :gutter="10">
        <el-col :span="9">
          <el-form-item
            :label="$l('form_label_ecom_warehouse_name') || '盘点仓库'"
            prop="ecomWarehouseCode"
          >
            <dict-select
              v-model="formData.ecomWarehouseCode"
              url="/ecom/warehouse/cn/warehouse/select"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              filterable
              clearable
              style="width:100%"
              :disabled="formDisabled || publishDisabled"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$l('form_label_begin_date') || '盘点开始日期'">
            <el-date-picker
              v-model="formData.beginDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
              readonly
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('table_label_adjust_date') || '数据调整日期'"
          >
            <el-date-picker
              v-model="formData.adjustDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
              readonly
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$l('table_label_stop_date') || '盘点终止日期'">
            <el-date-picker
              v-model="formData.stopDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
              style="width: 100%"
              readonly
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="9">
          <el-form-item :label="$l('INDEX.table_label_remarks') || '备注说明'">
            <el-input
              type="textarea"
              v-model="formData.remark"
              clearable
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              rows="3"
              maxlength="500"
              :disabled="formDisabled || publishDisabled"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$l('form_label_total_ctns') || '实盘总箱数'">
            <el-card
              class="card"
              shadow="never"
              style="border-color: #dcdfe6;height: 70px;"
            >
              <div style="text-align: left;">
                <span class="span-style">{{ formData.totalCtns }}</span>
              </div>
            </el-card>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('from_label_total_goods_qty') || '实盘总产品数'"
          >
            <el-card
              class="card"
              shadow="never"
              style="border-color: #dcdfe6;height: 70px;"
            >
              <div style="text-align: left;">
                <span class="span-style">{{ formData.totalGoodsQty }}</span>
              </div>
            </el-card>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('form_label_check_total_amount') || '总成本金额'"
          >
            <el-card
              class="card"
              shadow="never"
              style="border-color: #dcdfe6;height: 70px;"
            >
              <div style="text-align: left;">
                <span class="span-style">{{
                  formData.totalAmount.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                  })
                }}</span>
              </div>
            </el-card>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'

export default {
  mixins: [EditLoading],
  components: {},
  props: {
    amzFtyCheckTaskCode: { type: String, default: '' },
    formDisabled: { type: Boolean, default: false },
    publishDisabled: { type: Boolean, default: false },
    amzFtyCheckTaskStatus: { type: String, default: '' },
  },
  computed: {},
  data() {
    return {
      evgSkuCollectionParams: { dictType: 'skuCollection' },
      masterCategoryParams: { parentCode: 'ABSHome' },
      scmParams: {},
      formData: {
        amzFtyCheckTaskStatus: 'N',
        totalCtns: 0,
        totalGoodsQty: 0,
        totalAmount: 0.0,
      },
      rules: {
        ecomWarehouseCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.amzFtyCheckTaskCode) return
      this.$api
        .ecomAmzFtyCheckTaskDetailApi({
          amzFtyCheckTaskCode: this.amzFtyCheckTaskCode,
        })
        .then((res) => {
          this.formData = res.body
          this.$emit(
            'update:publishDisabled',
            this.formData.amzFtyCheckTaskStatus === 'P' ||
              this.formData.amzFtyCheckTaskStatus === 'Y' ||
              this.formData.amzFtyCheckTaskStatus === 'S'
          )
        })
    },
    async save(type, typeName) {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      let saveApi
      switch (type) {
        case 'startCounting':
          saveApi = this.$api.ecomAmzFtyCheckTaskStartCountingApi
          break
        case 'stopCounting':
          saveApi = this.$api.ecomAmzFtyCheckTaskStopCountingApi
          break
        case 'updateData':
          saveApi = this.$api.ecomAmzFtyCheckTaskUpdateDataApi
          break
        default:
          saveApi = this.$api.ecomAmzFtyCheckTaskSaveApi
          break
      }
      this.$confirm(
        `${this.$l('tips_whether_to_execute') ||
          '是否执行'} ${typeName}  ${this.$l('tips_Operation?') || '操作？'}`,

        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        saveApi(this.formData)
          .then(async (res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
              return
            }
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.closeCurPage()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.span-style {
  font-size: 30px;
  line-height: 22px;
  color: #888888;
}
</style>
